import Chip from '@mui/material/Chip';

export default function VisibilityChip({visibility, isDarkBackground = false}) {
  let label = visibility;
  let colorClass = isDarkBackground ? 'clr-white' : 'clr-primary';
  let borderColor = isDarkBackground
    ? getComputedStyle(document.documentElement).getPropertyValue('--white')
    : getComputedStyle(document.documentElement).getPropertyValue('--primary');

  if (visibility === 'USER_GROUP') {
    label = 'Everyone';
    colorClass = 'clr-success';
    borderColor = getComputedStyle(document.documentElement).getPropertyValue('--success');
  }
  if (visibility === 'PRIVATE') label = 'Private';

  return <Chip label={label} variant="outlined" className={colorClass} sx={{borderColor: borderColor}} />;
}
